import React, {useState, useEffect} from 'react';
import PropTypes from 'prop-types';
import View from './view';
import {api} from "careand-redux/api/ApiThunks";
import {useAppDispatch} from "careand-redux/useAppDispatch";
import {useAppSelector} from "careand-redux/store";
import {useIsLoading} from 'careand-redux/slices/ui/hooks';
import StripeUtils from 'services/StripeUtils';

const CreditCardScreen = props => {

  const dispatch = useAppDispatch();

  const ownRole = useAppSelector(state => state.authentication.role);
  const creditCards = useAppSelector(state => state.payments.creditCards);
  const patientCreditCards = creditCards[props.patient.id] || [];

  const [showModal, setShowModal] = useState(false);

  const patientId = props.patient.id;

  const loading = useIsLoading(api.Payments.getCreditCards)

  useEffect(() => {
    if (StripeUtils.isEnabled()) {
      dispatch(api.Payments.getCreditCards({patientId}))
    }
  }, [dispatch, patientId]);

  function onAddSuccess() {
    setShowModal(true);
    onChange(true);
  }

  function onChange(addedCard = false) {
    if (props.onChange) props.onChange(addedCard);
  }

  const isPatient = ownRole === "patient";

  return (
    <View
      {...props}
      isPatient={isPatient}
      loading={loading}
      showModal={showModal}
      creditCards={patientCreditCards}
      openModal={setShowModal}
      onAddSuccess={onAddSuccess}
      onChange={onChange}
    />
  );
}

CreditCardScreen.propTypes = {
  patient: PropTypes.object.isRequired,
  onChange: PropTypes.func,
  title: PropTypes.string,
  showButtons: PropTypes.bool
};

export default CreditCardScreen
